import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { API_URL } from '@core/config/api-url.token';
import { SUPPRESS_ERROR_TOAST } from '@core/http/http-context-tokens';
import { FEEDBACK_REPORT_ENDPOINT } from '../feedback-report-endpoint.token';
import { FeedbackReportDraft } from '../../../domain/models/feedback-report.model';
import { FeedbackReportReceiptDto } from '../../dtos/feedback-report.dto';

const SCREENSHOT_FILE_NAME = 'screenshot.png';

@Injectable()
export class FeedbackReportRemoteDatasource {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = inject(API_URL);
  private readonly endpoint = inject(FEEDBACK_REPORT_ENDPOINT);

  public submit(draft: FeedbackReportDraft): Observable<FeedbackReportReceiptDto> {
    const form = new FormData();
    form.append('message', draft.message);
    form.append('route', draft.route);
    if (draft.diagnostics) form.append('diagnostics', JSON.stringify(draft.diagnostics));
    if (draft.screenshot) form.append('screenshot', draft.screenshot, SCREENSHOT_FILE_NAME);
    for (const file of draft.attachments) form.append('files', file, file.name);

    // No Content-Type header: only the browser can append the multipart boundary to it.
    return this.http.post<FeedbackReportReceiptDto>(`${this.apiUrl}${this.endpoint()}`, form, {
      context: new HttpContext().set(SUPPRESS_ERROR_TOAST, true),
    });
  }
}
